export const services = {
  headers: {
    requestedService: "Service demandé",
  },
  actions: {
    discardRequest: "Rejeter la demande",
  },
  storeInactiveTitle: "La boutique de services n'est pas active",
  storeInactiveDesc1:
    "Pour recevoir des demandes d'expériences et de services complémentaires, vous devez activer votre boutique.",
  storeInactiveDesc2:
    "Une fois activée, vos voyageurs pourront demander des services directement depuis WhatsApp.",
  activateStoreBtn: "Activer la boutique de services",

  noServicesDesc1:
    "Activez les Expériences en configurant vos services complémentaires : petit-déjeuner, excursions, transferts, ou tout ce que vous proposez.",
  noServicesDesc2:
    "Vos voyageurs les verront juste après le check-in, directement dans WhatsApp.",
  addFirstServiceBtn: "Ajouter ma première expérience ou service",
};
